import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import MainNavbar from "../../components/Navbars/MainNavbar";

import dashboardStyle from "../../assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import Card from "../../components/Card/Card";
import CardHeader from "../../components/Card/CardHeader";
import { Info } from "@mui/icons-material";
import CardBody from "../../components/Card/CardBody";
import CardFooter from "../../components/Card/CardFooter";
import Button from "../../../components/Buttons/Button";

class Dashboard extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div>
        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Dashboard"} tKey={"dashboard.pagetitle"} />} />
        <GridContainer>
          <GridItem>
            <h1>
              <TranslationWrapper tDefault={"Welkom bij Jamezz®"} tKey={"dashboard.welkom.text"} />
            </h1>
            <b>
              <TranslationWrapper tDefault={"Support channels:"} tKey={"dashboard.support.text"} />
            </b>
            <br />
            <div style={{ marginLeft: "10px" }}>
              {<TranslationWrapper tDefault={"E-mail:"} tKey={"dashboard.support_mail.text"} />}{" "}
              <a href={"mailto:support@jamezz.nl"}>support@jamezz.nl</a>
              <br />
              {<TranslationWrapper tDefault={"Telephone:"} tKey={"dashboard.support_tel.text"} />}{" "}
              <a href={"tel:0031853013000"}>+31(0)85 - 301 3000</a>
              <br />
            </div>
          </GridItem>
        </GridContainer>
        <rn-banner
          background-color={"#242e3a"}
          button-text={getTranslation("changelog.open", "Open")}
          prefix-background-color={"#ff9800"}
          type={"update"}
        />

        <Card blog={true}>
          <CardHeader
            color={"primary"}
            style={{
              maxHeight: "50px",
              width: "max-content",
            }}
          >
            <div style={{ display: "flex" }}>
              <Info />
              <h4
                style={{
                  margin: "0 0 0 5px",
                  fontSize: "1.1em",
                }}
              >
                <TranslationWrapper tDefault={"Updates & Fixes"} tKey={"changelog.updates_and_fixes"} />
              </h4>
            </div>
          </CardHeader>
          <CardBody>
            <iframe
              src={"https://jamezz.releasenotes.io/?theme=15"}
              style={{
                width: "100%",
                height: "70vh",
                border: "0px",
              }}
              title={"todo"}
            />
          </CardBody>
          <CardFooter
            style={{
              borderTop: "solid 1px lightgrey",
              justifyContent: "end",
            }}
          >
            <Button
              onClick={() => {
                window.open("https://jamezz.releasenotes.io?theme=15", "_blank");
              }}
              size={"small"}
              style={{
                background: "#ff9800",
                color: "#fff",
              }}
              variant={"contained"}
            >
              <TranslationWrapper tDefault={"Open"} tKey={"changelog.open"} />
            </Button>
          </CardFooter>
        </Card>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(Dashboard, dashboardStyle);
